import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { MessageFeedbackComponent } from '@app/shared/components/message-feedback/message-feedback.component';
import { Observable } from 'rxjs';
import { ProcessoAvaliativo } from '@app/shared/models/processo-avaliativo';
import { SelectModule } from 'primeng/select';

@Component({
	selector: 'sgp-select-processo-avaliativo',
	standalone: true,
	imports: [ReactiveFormsModule, AsyncPipe, TitleCasePipe, SelectModule, MessageFeedbackComponent],
	templateUrl: './select-processo-avaliativo.component.html'
})
export class SelectProcessoAvaliativoComponent {
	@Input() control!: FormControl;
	@Input() options$?: Observable<ProcessoAvaliativo[]>;
	@Input() label = 'Processo Avaliativo (obrigatório):';
	@Input() showError = false;
	@Input() showFinalidade = true;
	@Input() placeholder = 'Selecione um processo avaliativo';
	@Input() dataCy = 'processo-avaliativo';
	@Output() changed = new EventEmitter<ProcessoAvaliativo | undefined>();
}
